import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {ICompany} from '../interfaces/company.interface';

@Injectable()
export class CompanyService extends ParentService {

  constructor(
    private http: Http
  ) {
    super();
  }

  get(
    showDisabled?: boolean,
    callTypeId?: number,
    dateOfService?: string,
    brokerId?: number,
    payorId?: number,
    orderBy?: boolean
  ): Observable<ICompany[]> {
    let url = constant.URL_COMPANIES;
    url += showDisabled ? `?showDisabled=${showDisabled}` : `?showDisabled=false`;
    url += callTypeId ? `&callTypeId=${callTypeId}` : ``;
    url += dateOfService ? `&dateOfService=${dateOfService}` : ``;
    url += brokerId ? `&brokerId=${brokerId}` : ``;
    url += payorId ? `&payorId=${payorId}` : ``;
    url += orderBy ? `&orderBy=${orderBy}` : ``;

    return this.http.get(url, this.getHeader())
      .map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/company.service.ts